import { GameManager } from "./../../GameManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";

export class GameOverLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        super(scene);

        const bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        bck.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        bck.on("pointerdown", () => { 
            // 
        });
        bck.alpha = 0;
        this.add(bck);

        let midContainer = new Phaser.GameObjects.Container(this.scene);
        midContainer.setPosition(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 - 100);
        midContainer.scaleX = GameVars.scaleX;
        this.add(midContainer);

        let titleBck = new Phaser.GameObjects.Image(this.scene, 0, 50, "texture_atlas_1", "campaign_" + (GameVars.currentMapZone + 1));
        titleBck.scaleX = .25;
        titleBck.alpha = 0;
        midContainer.add(titleBck);

        let title = new Phaser.GameObjects.Image(this.scene, 0, 37, "texture_atlas_1", "game_over_text");
        title.scaleX = .25;
        title.alpha = 0;
        midContainer.add(title);

        const resetButton = new Phaser.GameObjects.Image(this.scene, -50, 200, "texture_atlas_1", "btn_reset");
        resetButton.setInteractive();
        resetButton.on("pointerover", () => { this.onBtnOver(resetButton); });
        resetButton.on("pointerout", () => { this.onBtnOut(resetButton); });
        resetButton.on("pointerdown", () => { this.onClickRestart(); });
        resetButton.alpha = 0;
        resetButton.setScale(.5);
        midContainer.add(resetButton);

        const homeButton = new Phaser.GameObjects.Image(this.scene, 50, 200, "texture_atlas_1", "btn_menu");
        homeButton.setInteractive();
        homeButton.on("pointerover", () => { this.onBtnOver(homeButton); });
        homeButton.on("pointerout", () => { this.onBtnOut(homeButton); });
        homeButton.on("pointerdown", () => { this.onClickHome(); });
        homeButton.alpha = 0;
        homeButton.setScale(.5);
        midContainer.add(homeButton);

        this.scene.tweens.add({
            targets: bck,
            alpha: .75,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1500
        });

        this.scene.tweens.add({
            targets: [titleBck, title],
            angle: -1,
            ease: Phaser.Math.Easing.Cubic.In,
            duration: 250
        });

        this.scene.tweens.add({
            targets: [titleBck, title],
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 500,
            delay: 500,
            onStart: () => {
                AudioManager.playSound("banner_unroll");
            },
            onStartScope: this
        });

        this.scene.tweens.add({
            targets: [resetButton, homeButton],
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 500,
            delay: 1000
        });

        AudioManager.setSoundtrackVolume(0);

        this.scene.time.delayedCall(6250, function(): void {
            AudioManager.playSoundtrack("soundtrack_menus", .25);
        }, [], this);

        AudioManager.playSound("you_lose");
    }

    private onBtnOver(btn: any): void {

        if (btn.alpha === 1) {
            btn.setScale(1.1);
        }
    }

    private onBtnOut(btn: any): void {
        
        if (btn.alpha === 1) {
            btn.setScale(1);
        }
    }

    private onClickRestart(): void {

        GameManager.reset();

        AudioManager.playSound("btn_click");
    }

    private onClickHome(): void {

        GameManager.enterLobbyScene();
        
        AudioManager.playSound("btn_click");
    }
}
